/*
----- Notifications ----- 
Notification framework that gets used typically at the bottom of the window to show onload prompts to the user

Examples of use:
1. Cookie Policy acceptance.
2. PWA ( Progressive Web App ) installation prompt.
*/


var instances = new Object();

function setContext(id, value) {
    return instances[id]['context'] = value;
}

function getContext(id) {
    return instances[id]['context'];
}

function setType(id, value) {
    return instances[id]['type'] = value;
}

function getType(id) {
    return instances[id]['type'];
}

function setAcceptButton(id, value) {
    return instances[id]['proceed-button'] = value;
}

function getAcceptButton(id) {
    return instances[id]['proceed-button'];
}

function setCancelButton(id, value) {
    return instances[id]['cancel-button'] = value;
}

function getCancelButton(id) {
    return instances[id]['cancel-button'];
}


// Initialise every instance of [data-notification]
function initialiseAll() {
    AXISDebug.output(1, "Notifications: Initialising all notification on the page.")
    $('[data-notification]').each(function() {
        // Grab context. 
        let context = $(this);
        // Initialise 
        let init = initialise(context);

    });
}


function initialise(context) {
    // Get instance id.
    let id = context.attr(expressSelectors()['axis-notifications']['initialise']);
    // If no Id then generate one.
    if (!id) {
        context.attr(expressSelectors()['axis-notifications']['initialise'], generateId());
        id = context.attr(expressSelectors()['axis-notifications']['initialise']);
        instances[id] = {};
        // Update instance.
        setContext(id, context);
    } else {
        return false;
    }

    // Work out type, this attribute was introduced after the cookie & pwa notifications so have added appropriate fallbacks.
    let type = context.attr(expressSelectors()['axis-notifications']['type']);
    if (!type) {
        if (context.attr(expressSelectors()['axis-pwa']['initialise']) != undefined) {
            type = "pwa";
        } else {
            type = "cookie";
        }
    }
    setType(id, type);

    // Accept / Cancel buttons.
    const acceptButton = context.find('[' + expressSelectors()['axis-notifications']['accept-button'] + ']');
    setAcceptButton(id, acceptButton);
    const cancelButton = context.find('['+ expressSelectors()['axis-notifications']['cancel-button'] + ']');
    setCancelButton(id, cancelButton);

    if (acceptButton.length || cancelButton.length) {
        setListeners(id);
    }

    // Initialise PWA.
    if (type == "pwa") {
        AXISPWA.initialise(context).then((response) => {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Notifications: PWA detected attempting to trigger.", response);
            }
            // Get status.
            const status = (response.hasOwnProperty('status') ? response['status'] : false);
            if (status == "not-installed") {
                openNotification(context);
            } else {
                // Callback to server as the cookie that gets set to prevent this markup as been cleared.
                console.log("callback to server", status);
                if (status == "declined") {
                    cancelButton.trigger('do-lookup');
                } else {
                    acceptButton.trigger('do-lookup');
                }
            }
        });
    } 
    
}

function setListeners(id) {
    // Get notification context.
    let context = getContext(id);
    // Get notification type.
    let type = getType(id);
    // Get button contexts
    const acceptButton = getAcceptButton(id);
    const cancelButton = getCancelButton(id);

    if (acceptButton.length) {
        acceptButton.on('click', function() {
            switch(type) {
                case "pwa":
                    AXISPWA.install(context);
                    break;
                default:
                    console.log("Notifications: No accept procedure for this type.", context);
            }
            
        });
    }
    if (cancelButton.length) {
        cancelButton.on('click', function() {
            switch(type) {
                case "pwa":
                    AXISPWA.decline(context);
                    break;
                default:
                    console.log("Notifications: No cancel procedure for this type.", context);
            }
        });
    }
}

function openNotification(context) {
    return context.addClass('active');
}

function closeNotification(context) {
    // Close notification after timer.
    setTimeout(() => {
        return context.removeClass('active');
    }, 3000);
}

var notifications = $.notifications = {
    initialiseAll: () => {
        return initialiseAll();
    },
    initialise: (context) => {
        return initialise(context);
    },
    close: (context) => {
        return closeNotification(context);
    }
}

export { notifications };